// src/components/ui/GlobeStatic.tsx

import Image from 'next/image'

export const StaticGlobe = (): React.ReactNode => (
  <div className="relative aspect-[1/1] w-full max-w-[600px] mx-auto">
    <Image
      src="/images/globe-fallback-image-01.webp"
      alt="Global creative vantage visualization"
      width={1200}
      height={1200}
      priority
      className="absolute inset-0 w-full h-full object-cover"
      quality={60}
      sizes="(max-width: 600px) 100vw, 600px"
    />
  </div>
)